import { useEffect, useState, useRef, useContext, createContext } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";

import styles from "./TeamVerify.module.css"
import guestii from '../../assets/images/logos/guestii.svg'
import banner from '../../assets/images/banner.jpg'

import { MovingTextContainer } from '../Utils/Helpers'


const TeamVerify = () => {
	const param = useParams();
	const [validationError, setValidationError] = useState(null)
	const [formData, setFormData] = useState({})
	const [isLoading, setIsLoading] = useState(false)

	useEffect(() => {
		const handleLoad = async () => {
			try {
				const response = await axios.get(`/api/auth/team-verify/${param.roleId}/${param.userId}/${param.token}`)
				if (!response.data.valid) {
					setValidationError("The token has expired.")
					return;
				} else {
					setFormData({ _id: param.userId })
				}
			} catch (e) {
				console.log(e)
				setValidationError("The token has expired.")
				return;
			}

		}

		handleLoad()
	}, []);

	useEffect(() => {
		if (validationError) {
		  	const timer = setTimeout(() => setValidationError(null), 5000);
		  	return () => clearTimeout(timer);
		}
	}, [validationError]);

	const isValidEmail = (email) => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	}

	function isSixDigitCode(code) {
	    return /^\d{6}$/.test(code);
	}

    function isValidPassword(password) {
		const minLength = 8;
		const uppercaseRegex = /[A-Z]/;
		const lowercaseRegex = /[a-z]/;
		const numericRegex = /[0-9]/;

		if (password.length < minLength) {
			return "The password length must be greater than or equal to 8 characters";
		}

		if (!uppercaseRegex.test(password)) {
			return "The password must contain one or more uppercase characters";
		}

		if (!lowercaseRegex.test(password)) {
			return "The password must contain one or more lowercase characters";
		}

		if (!numericRegex.test(password)) {
			return "The password must contain one or more numeric values";
		}

		return true;
    }

	const handleForm = async (control, label, input) => {
		switch (control) {
			case 'set':
				let labelFormatted = label.replaceAll(" ", "_").toLowerCase()

				if (input.target) {
					setFormData((prev) => ({...prev, [labelFormatted]: input.target.value }))
				} else {
					setFormData((prev) => ({...prev, [labelFormatted]: input }))
				}
				break;
			case 'submit':
				if (!formData.hasOwnProperty('password') || formData.password === "") {
					setValidationError("Please make sure you enter a password")
					return false;
				} else {
					if (isValidPassword(formData['password']) !== true) {
						setValidationError(isValidPassword(formData['password']))
						return false;
					}
				}

				setValidationError(null)
				setIsLoading(true)

		    	const passwordResponse = await axios.post(`/api/auth/complete-team-registration`, {
		      		data: formData
		    	});

		    	if (!passwordResponse.data.valid) {
		    		setValidationError(passwordResponse.data.message)
		    		setIsLoading(false)
		    		return false;
		    	}

		    	setIsLoading(false)
				localStorage.removeItem("_id")
				localStorage.removeItem("expiry")
				window.location = "/connect"
				break;
		}
	}

	return (
		<div className={styles.container}>
			<div className={styles.content_container}>
			    {validationError &&
			        <div className={styles.error_banner}>
			          	<p className={styles.error_text}>{validationError}</p>
			        </div>
			    }

				<img src={guestii} className={styles.logo}/>
				<div className={styles.underline}/>

				<div className={styles.login_container}>
					<div className={styles.login_banner_container}>
						<h1 className={styles.l2}>Guestii Registration!</h1>
						<p className={styles.m1}>we are excited to welcome you</p>
					</div>

					<div className={styles.login_form}>
						<MovingTextContainer
							label={"Password"}
							icon={"fa-solid fa-unlock-keyhole"}
							handleForm={handleForm}
							formData={formData}
							classData={{
								location: "rstyles",
								name: "input_container"
							}}
							register={true}
							password={true}
						/>
					</div>

					<button className={styles.login_btn} onClick={() => handleForm('submit')}>
						<p>Register</p>
					</button>

					<div className={styles.signup_container}>
						<p className={styles.s2}>Already a guestii?&nbsp;</p><button><p className={styles.s2}>Login now!</p></button>
					</div>
				</div>
			</div>

			<div className={styles.banner_container}>
				<h3>Manage your events and guestlists seamlessly</h3>
				<p>Designed to create and manage events and guest lists, offering seamless invitations, role-based permissions, and real-time updates to enhance your event planning experience.</p>

				<div className={styles.circle_grid}>
					<div className={styles.circle}></div>
					<div className={styles.circle}></div>
					<div className={styles.circle}></div>
				</div>

				<img src={banner}/>
			</div>
		</div>
	)
};

export default TeamVerify;